// Single source of truth for where the backend lives.
//
// REACT_APP_API_URL is the full API root, e.g. https://rccgdominion.org/api
// (set it in .env.production before `npm run build`). It defaults to the local
// dev server. API_BASE is the same origin without the /api suffix and is what
// uploaded file paths (/uploads/...) are prefixed with.

const DEFAULT_API_URL = 'http://localhost:5000/api';

export const API_URL = (process.env.REACT_APP_API_URL || DEFAULT_API_URL).replace(/\/+$/, '');

// Strip only a trailing /api so hosts like https://api.example.org survive intact.
export const API_BASE = API_URL.replace(/\/api$/, '');

const isAbsolute = (value) => /^(https?:)?\/\//i.test(value) || /^(data|blob):/i.test(value);

export const resolveMediaUrl = (filePath) => {
  if (!filePath) return null;
  if (isAbsolute(filePath)) return filePath;
  return `${API_BASE}${filePath.startsWith('/') ? '' : '/'}${filePath}`;
};
